import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { nativeSetStatusBarAttributes } from '@perpay-web/native-client/actions/statusBar';
import { getIsReactNative } from '@perpay-web/native-client/getIsReactNative';

export const useTransparentStatusBar = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        const setTransparency = (isTransparent) => {
            if (!getIsReactNative()) {
                return;
            }

            document.documentElement.classList.toggle(
                'react-native--transparent-status-bar',
                isTransparent,
            );

            dispatch(nativeSetStatusBarAttributes({ hidden: isTransparent }));
        };

        setTransparency(true);
        return () => setTransparency(false);
    }, [dispatch]);
};
